import theme from '@styles/theme';
export default {
  locationItem: {
    padding: '16px 16px 16px 12px',
    background: theme.rawColors.neutralWhite,
    border: `1px solid ${theme.rawColors.lightGrey500}`,
    boxSizing: 'border-box',
    m: '0 0 10px',
    cursor: 'pointer',
    p: {
      m: '8px 0 0'
    }
  }
};